<template>
  <div id="header">
    <router-link to="/"><h1>ポストエクスプレス<span>&reg;</span>WEB（栃木県央版）</h1></router-link>
    <login-panel :user="user" @login="login"></login-panel>
  </div>
  <router-view :user="user" @login="login" />
  <div id="footer">
    <label>&copy; 2021 PE.アライアンス株式会社</label>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, provide } from 'vue';
import { AreaSelection } from '@/types/AreaSelection';
import { clsEstimateCond } from '@/types/clsEstimateCond';
import { clsEstimateData } from '@/types/clsEstimateData';
import LoginPanel from '@/components/LoginPanel.vue';
import { clsUser } from '@/types/clsUser';

export default defineComponent({
  components: { LoginPanel },
  setup() {
    const AreaSelection: AreaSelection = reactive({
      weekly: [],
      monthly: []
    })
    provide('area_selection', AreaSelection)
    const user = reactive(new clsUser())
    //provide('user', user)
    function login(arg: any) {
      Object.assign(user, arg)
    }
    const EstimateCond: clsEstimateCond = reactive(new clsEstimateCond('nokina','B4'))
    provide('econd', EstimateCond)
    const EstimateData: clsEstimateData = reactive(new clsEstimateData())
    provide('estdata', EstimateData)

    return {
      user,
      login
    }
  }
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#header {
  color: #F1F1F1;
  background-color: #215892;
  display: flex;
  justify-content: space-between;
}
#header h1 {
  font-size: 18px;
  margin: 0;
  padding: 5px 12px;
}
#header h1 span {
  vertical-align: super;
  font-size: smaller;
}
#header a {
  color: white;
  text-decoration: none;
}
#main {
  height: calc(100% - 69px);
  overflow: auto;
}
#footer {
  padding: 5px 10px;
  background-color: #888888;
  color: gainsboro;
  text-align: right;
  font-size: small;
}
#footer a {
  color: gainsboro;
  text-decoration: none;
}
</style>
